
import React from "react";

export default function MapPin ({ className, color }) {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 12.674V17C11.25 17.414 11.586 17.75 12 17.75C12.414 17.75 12.75 17.414 12.75 17V12.674C15.288 12.306 17.25 10.138 17.25 7.5C17.25 4.605 14.895 2.25 12 2.25C9.105 2.25 6.75 4.605 6.75 7.5C6.75 10.138 8.712 12.306 11.25 12.674ZM12 3.75C14.068 3.75 15.75 5.432 15.75 7.5C15.75 9.568 14.068 11.25 12 11.25C9.932 11.25 8.25 9.568 8.25 7.5C8.25 5.432 9.932 3.75 12 3.75ZM19.75 18C19.75 20.138 16.418 21.75 12 21.75C7.582 21.75 4.25 20.138 4.25 18C4.25 16.426 5.97001 15.1381 8.85101 14.5551C9.26001 14.4751 9.65299 14.735 9.73499 15.141C9.81799 15.547 9.55499 15.943 9.14899 16.025C6.91799 16.477 5.75 17.361 5.75 18C5.75 18.917 8.185 20.25 12 20.25C15.815 20.25 18.25 18.917 18.25 18C18.25 17.361 17.083 16.477 14.851 16.025C14.445 15.943 14.183 15.547 14.265 15.141C14.347 14.735 14.744 14.4751 15.149 14.5551C18.03 15.1381 19.75 16.426 19.75 18Z"
        fill={(color)||"#6F6C99"}
      />
    </svg>
  );
};
